import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { Case } from 'src/app/modules/cases/_types/case';
import { PublicCaseService } from '../../_services/public-case.service';
import { CasesService } from 'src/app/modules/cases/_services/cases.service';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { CasesFilesService } from 'src/app/modules/cases/_services/cases-files.service';
import { CaseFile } from 'src/app/modules/cases/_types/case-file';
import { environment } from 'src/environment/environment';
import { File } from '../../../common/_types/file'
import { CasesServicesService } from 'src/app/modules/cases/_services/cases-services.service';
import { CaseService } from 'src/app/modules/cases/_types/case-service';
import { CasesNotesService } from 'src/app/modules/cases/_services/cases-notes.service';
import { CaseNote } from 'src/app/modules/cases/_types/case-note';
import { CasesDetailNoteComponent } from 'src/app/modules/cases/cases-detail/note/note.component';
import { DialogService } from 'primeng/dynamicdialog';
import { ThisReceiver } from '@angular/compiler';
import { FilesService } from 'src/app/modules/common/_services/files.service';
import { date } from '@rxweb/reactive-form-validators';
import moment from 'moment';
import { NotesClientComponent } from 'src/app/modules/cases/cases-detail/notes-client/notes-client.component';
import { PublicBusinessService } from '../../_services/public-business.service';
import { Business } from 'src/app/modules/business/_types/business';


@Component({
    selector: 'app-public-legal-terms',
    templateUrl: './terms.component.html',
    styleUrls: ['./terms.component.css'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PublicLegalTermsComponent  {

  public business: Business | null = null;

  constructor(
    private route:ActivatedRoute,
    private publicBusinessService: PublicBusinessService
  ){
    let businessId = this.route.snapshot.paramMap.get('businessId');
    if(businessId) this.loadBusiness(businessId);
  }

  async loadBusiness(id: string){
    this.business = await firstValueFrom(this.publicBusinessService.get(id));
  }

  goBack(){
    history.back();
  }
}
